<template>
  <one-column-sidebar-left
      :id="$route.params.id"
      back-button-tab-selector="sfxbackbutton"
      sub-menu-selector="librarypanel"
      tab-selector="assemblytab"
  >
    <!---Main Info Panel-->
    <info-panel :id="$route.params.id"
                slot="sidebarLeft"
                :created="$store.getters.getAssemblyCreationDate($route.params.id)"
                :downloadable="true"
                :image-editable="true"
                :last-change="$store.getters.getAssemblyChangeDate($route.params.id)"
                :media-type="$store.getters.getAssemblyType(this.$route.params.id)"
                :organization="$store.getters.getAssemblyOrganization($route.params.id)"
                :preview-uri="$store.getters.getAssemblyPreviewUri($route.params.id)"
                class="new-style bright"
                preview-id="sfxedit"
                upload-type="Asset"
    >
      <div v-if="$store.getters.isSuperAdmin" slot="info" class="form-section">
        <div class="lighter uppercase">{{ $t('sourceProjectId') }}</div>
        {{ $store.getters.getAssemblySourceProjectId($route.params.id) }}<br/>
        <div class="mt-2 mb-2">
          <span class="lighter">
            <icon type="folder"/> STORAGE</span><br/>
          <span class="small">{{
              `${$store.getters.getAssemblyOrganization($route.params.id)}/assets/${this.$route.params.id}`
            }}</span>
        </div>
        <router-link v-if="$store.getters.isSuperAdmin || $store.getters.isSFXMember"
                     :to="'/library/3d-data/add-asset-bundle/' + $route.params.id"
                     class="mt-3 darker p-2 border-radius">
          Edit asset bundle
          <icon type="arrow-up-right-from-square"/>
        </router-link>
      </div>
    </info-panel>

    <!--TAGS-->
    <info-panel
        :id="$route.params.id"
        key="infopanel2"
        slot="sidebarLeft"
        :limit-tags-to-organization="$store.getters.getAssemblyOrganization($route.params.id)"
        :taggable="hasWritingAccess"
        :tags="$store.getters.getAssemblyTags($route.params.id)"
        class="new-style bright"
        preview-id="sfxedit"
        @addTag="addTag"
        @removeTag="removeTag"
    />

    <!--TEAMS-->
    <team-attacher
        v-if="$store.getters.getAssemblyOrganization($route.params.id)"
        :id="$route.params.id"
        slot="sidebarLeft"
        :limit-by-organization-id="$store.getters.getAssemblyOrganization($route.params.id)"
        :read-only="!hasWritingAccess"
        :teams="teams"
        class="mt-3 new-style bright"
        store-name="Asset"
        @added="loadAssetTeams"
        @removed="loadAssetTeams"
    />

    <div slot="mainContent">
      <!--TITLE-->
      <name-display-edit-block
          :max-name-length="500"
          :id="$route.params.id"
          :display-name="$store.getters.getAssemblyDisplayName($route.params.id)"
          :editable="isNotLocked && hasWritingAccess"
          :name="$store.getters.getAssemblyName($route.params.id)"
          :organization-id="$store.getters.getAssemblyOrganization($route.params.id)"
          icon="assembly"
          store-name="Assembly"
      />
      <!--LOCK-STATUS-->
      <div v-if="!isNotLocked" class="form-error">
        {{ $t('assemblyIsLocked') }}
      </div>
      <!--DESCRIPTION-->
      <content-description-block
          :id="$route.params.id"
          :editable="isNotLocked && hasWritingAccess"
          :value="$store.getters.getAssemblyDescription($route.params.id)"
          store-name="Assembly"
      />
      <div class="row">

        <!--STATE-->
        <state-setter
            :read-only="!isNotLocked || !hasWritingAccess || showUpdateForm || showPipelineForm || (!$store.getters.isSuperAdmin && isCurrentlyProcessing)"
            :given-state="$store.getters.getAssemblyState($route.params.id)"
            :target-id="$route.params.id"
            class="col-12 col-md-4 mb-3"
            store-name="Assembly"
        />
        <div class="w-100" />
        <glb-conversion-trigger
            v-if="!hideGlbForm && !hasGlb && isNotLocked && hasWritingAccess && !isCurrentlyProcessing && pipelineStatus === 'finished'"
            :asset-id="$route.params.id"
            class="col-12 col-md-4 mt-3 mb-3"
            type="assembly"
            @taskStarted="hideGlbForm = true"
        />
        <div class="w-100"/>
        <div v-if="!hasGlb && hideGlbForm" class="form-error col-12 col-md-4 ml-3">
          {{ $t('yourDataGetsConverted') }}
        </div>

        <div class="col-12 mb-3">
          <div class="row">
            <div class="col-12">
              <div class="darker p-2 border-radius">
                <h2>3D-Data Information</h2>
                <div class="float-right text-right">

                </div>
                <log-entry-information
                    :vm-log-entries="vmLogListItems"
                    :show-time-block="false"
                    :show-status-block="false"
                />
              </div>
            </div>
          </div>
        </div>

      </div>



      <!--IMPORT PANEL-->
      <info-panel
          v-if="hasWritingAccess"
          :collapsible="true"
          :initially-collapsed="!isCurrentlyProcessing && !showPipelineForm && !showAbortedMessage && !isInQueue"
          class="new-style bright"
          info-panel-header="currentSfxDataProcess"
          preview-id="fileProcessing"
      >
        <div slot="info" class="row p-2">
          <div
              v-if="$store.getters.isSuperAdmin"
              class="live-updater p-1 ml-3 border-radius mb-3">
            Receiving Live Updates
            <icon :type="continueUpdatingImportView ? 'check' : 'ban'"/>
          </div>
          <div class="w-100"/>
          <div class="col-12">
            <div class="row">
              <template v-if="showPipelineForm">
                <div class="col-12 mb-1">
                  <h2 class="font-weight-bold">{{ hasRoot ? $t('updateSfxdata') : $t('importSFX') }}</h2>
                </div>
                <!--IMPORT FORM-->
                <div class="col-8">
                  <assembly-import-config
                      v-if="content"
                      :asset-id="$route.params.id"
                      :content="content"
                      :has-root="hasRoot"
                      :old-content="oldContent"
                      :organization-id="$store.getters.getAssemblyOrganization($route.params.id)"
                      :pipeline-status="pipelineStatus"
                      :teams="teams"
                      @startingTask="startingTask"
                      @taskStarted="taskStarted"
                      @abort="removeAbortedState"
                  />
                </div>
              </template>


              <!--2 WHILE IMPORTING--->
              <!--PROGRESS INFORMATION-->
              <log-entry-progress
                  v-if="showProgress"
                  :id="$route.params.id"
                  :is-update="isUpdate"
                  :log-entry="currentVMLog"
                  class="col-12 col-md-8 mt-1"
              />
              <pipeline-state-viewer
                  :show-aborted-message="showAbortedMessage"
                  :object-id="$route.params.id"
                  :task-entry="mappedTask"
                  :class="'col-12 col-md-4'"
                  :newest-logentry="newestLogEntry"
                  @abort="forceShowAborted = true"
                  @removeAbortedState="removeAbortedState"
              />
            </div>
          </div>
        </div>
      </info-panel>


      <!--LOWER PANELS--->
      <div class="row">
        <div class="col-12">
          <info-panel
              :initially-collapsed="true"
              :collapsible="true"
              class="new-style bright"
              info-panel-header="Usage"
              preview-id="usage">
            <div slot="info">
              <asset-usage :asset-id="$route.params.id" />
            </div>
          </info-panel>
        </div>
        <!--VM LOGS-->
        <div class="col-12">
          <info-panel
              :collapsible="true"
              :initially-collapsed="false"
              class="new-style bright"
              info-panel-header="sfxDataLogHistory"
              preview-id="vmlogs"
          >
            <pipeline-history-viewer
                slot="info"
                :task-entries="vmLogListItems"
                @reload="loadAssembly"
            />
          </info-panel>
        </div>

        <!--ATTACH METASETS-->
        <div class="col-12 col-lg-6 no-gutters">
          <info-panel
              v-if="$store.getters.isSuperAdmin"
              :collapsible="true"
              :initially-collapsed="true"
              class="new-style bright"
              info-panel-header="sfx add metasets"
              preview-id="metasetattacher"
          >
            <meta-set-attacher
                slot="info"
                :given-meta-sets="$store.getters.getAssemblyMetaSets($route.params.id)"
                :target-id="$route.params.id"
                store-name="Asset"
                @added="loadAssembly"
                @removed="loadAssembly"
            />
          </info-panel>
        </div>

        <!--META-PANELS-->
        <template v-if="($store.getters.isSuperAdmin || $store.getters.isSFXMember)&& Object.keys($store.getters.getAssemblyMetaSets($route.params.id)).length && hasWritingAccess">
          <meta-panel
              v-for="(item) in $store.getters.getAssemblyMetaSets($route.params.id)"
              :key="item.id"
              :fields="item.metaFields"
              :organization-ids="[$store.getters.getAssemblyOrganization($route.params.id)]"
              :title="'MetaSet: ' + item.description"
              class="col-12 col-lg-6"
              classes="new-style bright"
              icon-left="folder"
              store-name="Assembly"
              type="Assembly"
              @updated="loadAssembly"
          />
        </template>


        <!--TASKMANAGER-->
        <div v-if="($store.getters.isSuperAdmin || $store.getters.isSFXMember) && dataRow" class="col-6">
          <table class="w-100">
            <tr>
              <th>Taskmanager</th>
            </tr>
            <dataset-row-taskmanager
                v-if="dataRow.data && taskmanagerFields"
                :data-row="dataRow"
                :dataset-id="SpecialUuids['TASKMANAGER_DATASET']"
                :fields="taskmanagerFields"
                :hidden-fields="[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18]"
                type="Asset"
            />
          </table>
        </div>

        <!--raw code-->
        <div class="col-6">
          <info-panel
              v-if="$store.getters.isSuperAdmin"
              :collapsible="true"
              :initially-collapsed="true"
              class="new-style bright"
              info-panel-header="RAW"
              preview-id="codem"
          >
            <div slot="info">
              <codemirror
                  :hide-abort-button="true"
                  :value="JSON.stringify($store.getters.getAssemblyContent(this.$route.params.id))"
                  class="col-12"
                  @save="updateContentField"
              />
            </div>
          </info-panel>
        </div>
        <div class="col-6">
          <info-panel
              v-if="projectId && ($store.getters.isSuperAdmin || $store.getters.isSFXMember)"
              :collapsible="true"
              :initially-collapsed="true"
              class="new-style bright"
              info-panel-header="Cache"
              preview-id="crossproject">
            <div slot="info">
              <assembly-caching-handler
                  :project-id="projectId"
                  class="p-3 assembly-caching-handler mt-2 mb-2 border-radius"
              />
            </div>
          </info-panel>
        </div>

      </div>
    </div>
  </one-column-sidebar-left>
</template>

<script>
import InfoPanel from "../components/InfoPanel";
import OneColumnSidebarLeft from "../layouts/OneColumnSidebarLeft";
import NameDisplayEditBlock from "@/components/NameDisplayEditBlock.vue";
import ContentDescriptionBlock from "../components/ContentDescriptionBlock";
import MetaPanel from "../components/widgets/meta/MetaPanel";
import Icon from "../components/Icon";
import {mapState} from 'vuex';
import VuelidateMixin from "@/components/mixins/VuelidateMixin.js";
import MetaSetAttacher from "@/components/widgets/meta/MetaSetAttacher";
import TeamAttacher from "@/components/organizations/TeamAttacher";
import StateSetter from "@/components/StateSetter";
import {TaskManagerTaskTypes, SpecialUuids} from "@/enum";
import LogEntryProgress from "@/components/pipeline/LogEntryProgress.vue";
import DatasetRowTaskmanager from "../components/widgets/dataset/DatasetRowTaskmanager";
import Codemirror from "../components/widgets/editors/Codemirror";
import AssemblyImportConfig from "../components/assemblies/AssemblyImportConfig";
import GlbConversionTrigger from "../components/assemblies/GlbConversionTrigger";
import AssemblyCachingHandler from "@/components/AssemblyCachingHandler.vue";
import PipelineStateViewer from "@/components/pipeline/PipelineStateViewer.vue";
import PipelineHistoryViewer from "@/components/pipeline/PipelineHistoryViewer.vue";
import {getIsCurrentlyProcessing, getMappedTask, getPipelineTask} from "@/pipelineUtils";
import LogEntryInformation from "@/components/pipeline/LogEntryInformation.vue";
import vmLogList from "@/components/pipeline/vmLogList";
import AssetUsage from "@/components/AssetUsage.vue";
export default {
  name: 'SFXEdit',
  components: {
    InfoPanel,
    MetaPanel,
    OneColumnSidebarLeft,
    NameDisplayEditBlock,
    ContentDescriptionBlock,
    Icon,
    MetaSetAttacher,
    TeamAttacher,
    StateSetter,
    LogEntryProgress,
    DatasetRowTaskmanager,
    Codemirror,
    AssemblyImportConfig,
    GlbConversionTrigger,
    AssemblyCachingHandler,
    PipelineStateViewer,
    PipelineHistoryViewer,
    LogEntryInformation,
    AssetUsage
  },
  mixins: [VuelidateMixin],
  data() {
    return {
      isLoading: false,
      forceReRenderKey: 0,
      hideGlbForm: false,
      hasGlb: true,
      taskmanagerFields: [],
      hasWritingAccess: false,

      SpecialUuids: SpecialUuids,
      showLoading: false,
      forceShowProgress: false,
      forceShowQueue: false,
      content: {},

      pipelineStatus: 'finished',
      pipelineTask: '',
      pipelineTaskId: null,

      forceShowAborted: false,

      teams: [],

      TaskManagerTaskTypes: TaskManagerTaskTypes,
      dataRow: null,

      /**
       * The root file to import
       * */
      hasRootFile: true,
      /**
       * Whether or not the assembly has already a root node
       * */
      hasRoot: false,
      instances: [],
      projectId: null,
      currentVMLog: {},
      // this is a vmLogList
      vmLogList: {},
    };
  },
  computed: {
    ...mapState({
      AssemblyList: state => state.dynamicStore.AssemblyLists.AssemblyList,
    }),
    showUpdateForm() {
      return this.isUpdate && !this.isAborted;
    },
    pipelineContent() {
      return this.content && this.content.pipeline ? this.content.pipeline : {};
    },
    isUpdate() {
      return !!(this.pipelineContent && this.pipelineContent.showUpdateForm);
    },
    isInitial() {
      return !!(this.pipelineContent && this.pipelineContent.showInitialForm && !this.isAborted);
    },
    showAbortedMessage() {
      return !!(this.pipelineContent && this.pipelineContent.isAborted);
    },
    showPipelineForm() {
      if (!this.pipelineTask && (this.isUpdate || this.isInitial)) {
        return true;
      }
      return false;
    },
    isInQueue() {
      if (this.mappedTask) {
        return this.mappedTask.prio === 999;
      }
      return false;
    },
    isCurrentlyProcessing() {
      if (this.forceShowProgress) {
        return true;
      }
      return getIsCurrentlyProcessing(this.mappedTask);
    },
    mappedTask() {
      return getMappedTask(this.dataRow);
    },
    /**
     * Checks if a versioning-process is running (which is locking the database fields)
     * */
    isNotLocked() {
      if (this.mappedTask) {
        return ![
          this.TaskManagerTaskTypes.VERSION_CREATE,
          this.TaskManagerTaskTypes.VERSION_DELETE,
          this.TaskManagerTaskTypes.VERSION_RESTORE
        ].includes(this.mappedTask.task)
      }
      return true;
    },
    continueUpdatingImportView() {
      return this.forceShowProgress || (this.mappedTask && [999, 777, 778].includes(this.mappedTask.prio)) || this.forceShowAborted || this.isCurrentlyProcessing;
    },
    oldContent() {
      if(this.vmLogList) {
        const items = this.vmLogList.getItems();
        if(items.length) {
          const target = items.filter(item => {
            return (item.task === 'update' || item.task === 'extract') && !!item.vmStoppedAt;
          });
          return target && target.length ? target[0].config : {};
        }
      }
      return {};
    },
    vmLogListItems() {
      return this.vmLogList && this.vmLogList.getItems ? this.vmLogList.getItems() : [];
    },
    showProgress() {
      return !this.showUpdateForm && !this.showPipelineForm;
    },
    newestLogEntry() {
      return this.vmLogList && this.vmLogList.getNewestEntry ? this.vmLogList.getNewestEntry() : {};
    }
  },
  watch: {
    continueUpdatingImportView(newVal) {
      if (newVal) {
        this.reloadAssemblyUntilAbort();
      }
    },
    pipelineTask() {
      this.forceShowQueue = false;
    }
  },
  beforeMount() {
    this.loadAssetTeams();
    this.loadAssembly();
  },
  beforeDestroy() {
    this.continueUpdatingImportView = false;
    this.isLoading = false;
  },
  methods: {
    async reloadAssemblyUntilAbort() {
      this.isLoading = true;
      await this.loadAssembly();
      const $this = this;
      setTimeout(() => {
        $this.isLoading = false;
      });
      if (this.continueUpdatingImportView) {
        setTimeout(() => {
          this.reloadAssemblyUntilAbort();
        }, 15000);
      }
    },
    async removeAbortedState() {
     return await this.loadAssembly()
          .then(async () => {
            this.content.pipeline.isAborted = false;
            this.content.pipeline.showInitialForm = false;
            this.content.pipeline.showUpdateForm = false;
            return await this.updateContentField(JSON.stringify(this.content));
          }).then(async () => {
            return this.loadAssembly();
          })
    },
    startingTask() {
      this.showLoading = true;
      this.forceShowQueue = true;
    },
    taskStarted() {
      this.showLoading = false;
      this.forceShowProgress = true;
      this.loadAssembly();
    },
    loadUsage() {
      this.$store.dispatch('clientGetCrossProjectInstances', {
        filter: 'assetId eq ' + this.$route.params.id
      }).then(instances => {
        this.instances = instances;
      })
    },
    /**
     * Updates the current content field
     * */
    async updateContentField(content) {
      this.$store.dispatch('clientSaveAsset', {
        id: this.$route.params.id,
        content: content
      }).then(() => {
        this.loadAssembly();
      })
    },
    /**
     * Loads the teams of the assembly
     * */
    loadAssetTeams() {
      this.$store.dispatch('clientLoadAssetTeams', {
        id: this.$route.params.id
      }).then(data => {
        this.teams = data;
      });
    },
    /***
     * Loads the root node of the assembly (if available)
     * */
    async loadRootNode(projectId) {
      return this.$store.dispatch('clientLoadProjectInstances', {
        id: projectId,
        filter: 'type in node model, level eq 1, parentId eq null'
      });
    },
    // checks if the assembly has glb files or not and sets the hasGlb flag
    async checkGlbFile(rootNodeId) {
      return await this.$store.dispatch('clientListInstanceParts', {
        id: rootNodeId
      }).then(files => {
        if (!files || !files.filter(item => {
          return item.key === 'lod0.glb'
        }).length) {
          this.hasGlb = false;
        }
      }).catch(e => {
        console.log(e);
      })
    },
    /**
     * Loads the assembly
     * */
    async loadAssembly() {
      // load the assembly
      return this.$store.dispatch('loadAssembly', {
        id: this.$route.params.id,
        include: 'tags,metaSets,teams,VMLogs,TaskManagerRow',
      }).then(async asset => {
        const {sourceProjectId, content, taskManagerRows, vmLogs} = asset;
        try {
          this.content = JSON.parse(content);
        } catch {
          console.log('could not parse asset content')
          this.content = content;
        }
        this.setPipelineTask(taskManagerRows);
        const list = new vmLogList(vmLogs);
        list.sortByUpdated();
        this.vmLogList = list;
        if (this.pipelineTaskId) {
          this.currentVMLog = this.vmLogList.getEntryByTaskEntryId(this.pipelineTaskId);
        }
        this.projectId = sourceProjectId;
        await this.checkWritingAccess(asset); // this should not have to be async, but I won't rewrite the whole permission system nowb
        // instead of loading the root node and glb each time, consider write the existence of a glb file into a metafield – for later
        return this.loadRootNode(this.projectId);
      }).then(async res => {
        this.hasRoot = !!(res && res.length);
        if (this.hasRoot) {
          await this.checkGlbFile(res[0].id);
        }
      }).catch(e => {
        if (e.status === 401) {
          this.denyAccess();
        } else if (e.status === 404) {
          this.$router.push('/not-found')
        }
      });
    },
    setPipelineTask(taskManagerRows) {
      const {pipelineTask, pipelineTaskId, dataRow} = getPipelineTask(taskManagerRows);
      this.dataRow = dataRow;
      this.pipelineTask = pipelineTask;
      this.pipelineTaskId = pipelineTaskId;
    },
    /**
     * Checks whether the user has read/write access to the assembly
     * */
    async checkWritingAccess(asset) {
      this.hasWritingAccess = await this.$store.dispatch('checkTeamOrgPermission', {
        op: 'writeMetaSet',
        teams: asset.teams,
        organizationId: asset.organizationId
      })
    },
    /**
     * Reroutes the user to the access denied page
     * */
    denyAccess() {
      this.$router.push('/access-denied');
    },
    /**
     * Removes the tag
     * */
    removeTag: function (tag) {
      this.$store.dispatch('removeAssemblyTag', {
        id: this.$route.params.id,
        args: [tag.id],
      });
    },
    /**
     * Adds the tag
     * */
    addTag: function (tag) {
      this.$store.dispatch('addAssemblyTag', {
        id: this.$route.params.id,
        args: [tag.id],
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.live-updater {
  background-color: var(--vform-editor-ui-quinary-color);
}
</style>